import { useContext, useMemo } from 'react';
import { MultiStepFormContext, useWatch } from '@kanda-libs/ks-component-ts';
import { YOUR_INFO_FIELDS } from 'pages/ApplyForFinance/Pages/YourInfo/constants';

export default function useAdditionalInfoForm(isSubmitting: boolean) {
  const {
    data: { isLoading, provider },
  } = useContext(MultiStepFormContext);

  const [accountInName, noIvaOrBankcruptcy] = useWatch({
    name: [YOUR_INFO_FIELDS.CONFIRM_ACCOUNT, YOUR_INFO_FIELDS.BANKRUPTCY_IVA],
  });

  const nextButtonProps = useMemo(
    () => ({
      disabled:
        isSubmitting || isLoading || !noIvaOrBankcruptcy || !accountInName,
      label: provider === 'etika' ? 'Continue' : 'Submit',
    }),
    [provider, isSubmitting, isLoading, accountInName, noIvaOrBankcruptcy],
  );

  return {
    nextButtonProps,
  };
}
